// @flow
import CommentString from './CommentString';

export default CommentString;
